module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/launch-calls-aa8dc81afe5be94750a78f2c8d403de5.svg";